import img_ensure_wa2 from "../../../assets/images/splashscreens/ensure-gold.jpg";
import img_glucerna_wa3 from "../../../assets/images/splashscreens/glucerna-2.jpg";
import "../../../styling/style-qrpage-redirect.css";

const QRPageRedirect = ({ qrcode, mechanics, phoneNumber }) => {
  // Determine which image to show
  const imgSrc = mechanics === "whatsapp3" ? img_glucerna_wa3 : img_ensure_wa2;

  // Use custom phone number if provided, otherwise use default
  const phone = phoneNumber || "60123499609";

  return (
    <section className="section-ensure-gold">
      <a
        href={`https://api.whatsapp.com/send?phone=${phone}&text=%F0%9F%92%9B%20Click%20Send%20to%20unlock%20promotion%20now!%20(Special%20code%3A%20${qrcode})`}
        target="_blank"
        rel="noreferrer"
      >
        <img src={imgSrc} alt="QR Redirect" className="img-ensure-gold" />
      </a>
    </section>
  );
};
export default QRPageRedirect;
